import TrainingListPage from '@/pages/cleaner/training-list'
import GoodsListPage from '@/pages/cleaner/goods-list'
import OrderListPage from '@/pages/cleaner/order-list'
import TypeListPage from '@/pages/cleaner/type-list'
import ItemListPage from '@/pages/cleaner/item-list'
import AccounListPage from '@/pages/cleaner/account-list'
import Inventory from '@/pages/cleaner/inventory'
import InventoryDetail from '@/pages/cleaner/inventory/inventory-details'

import TestNormalTable from '@/pages/cleaner/test-normal-table'
// import AccountEditPage from '@/pages/cleaner/account-edit'
import HousekeeperAccountEditPage from '@/pages/cleaner/housekeeper-account-edit'
import MaterialCollarListPage from '@/pages/cleaner/materialCollar-list'
import HousekeepingMaterialsListPage from '@/pages/cleaner/housekeepingMaterials-list'
import MaterialUpdateDetailsListPage from '@/pages/cleaner/materialUpdateDetails-list'
import dutyBillListPage from '@/pages/cleaner/dutyBill-list'
import dutyOrderListPage from '@/pages/cleaner/dutyOrder-list'
import cleanBillListPage from '@/pages/cleaner/clean-bill-list'
import additionalFeePage from '@/pages/cleaner/additional-fee'
import HousekeeperBillList from '@/pages/cleaner/housekeeperBill-list'
import CleaningTaskList from "@/pages/cleaner/cleaningTask-list.vue"
import PaymentDetails from '@/pages/cleaner/payment-details'

// 丽家会线上培训管理
export const trainingList = {
  path: 'cleaner/trainingList',
  component: TrainingListPage
}

// 丽家会物品管理
export const cleanerGoodsList = {
  path: 'cleaner/goodsList',
  component: GoodsListPage
}

// 丽家会清洁单管理
export const cleanerOrderList = {
  path: 'cleaner/orderList',
  component: OrderListPage

}

// 丽家会清洁单类型管理
export const cleanerTypeList = {
  path: 'cleaner/typeList',
  component: TypeListPage
}

// 丽家会清洁项目管理
export const cleanerItemList = {
  path: 'cleaner/itemList',
  component: ItemListPage
}

export const testNormalTable = {
  path: 'cleaner/testNormalTable',
  component: TestNormalTable
}

// 丽家会管家信息账号查看
export const cleanerAccountList = {
  path: 'cleaner/accountList',
  component: AccounListPage
}

// export const cleanerAccountEdit = {
//   path: 'cleaner/accountEdit',
//   component:AccountEditPage
// }

//修改管家账号
export const housekeeperAccountEdit = {
  path: 'cleaner/HousekeeperAccountEdit',
  component: HousekeeperAccountEditPage
}
//出入库
export const inventory = {
  path: 'cleaner/inventory',
  component: Inventory
}
export const inventoryDetail = {
  path: 'cleaner/inventoryDetails',
  component: InventoryDetail
}
//物资领用
export const MaterialCollarList = {
  path: 'cleaner/MaterialCollarList',
  component: MaterialCollarListPage
}
//管家物资出入库表
export const housekeepingMaterialsList = {
  path: 'cleaner/HousekeepingMaterialsList',
  component: HousekeepingMaterialsListPage
}

//管家库存明细表
export const materialUpdateDetailsList = {
  path: 'cleaner/MaterialUpdateDetailsList',
  component: MaterialUpdateDetailsListPage
}
//值班账单列表
export const dutyBillList = {
  path: 'cleaner/dutyBillList',
  component: dutyBillListPage
}
//值班单管理
export const dutyOrderList = {
  path: 'cleaner/dutyOrderList',
  component: dutyOrderListPage
}

export const cleanBillList = {
  path: 'cleaner/cleanBillList',
  component: cleanBillListPage
}

export const additionalFee = {
  path: 'cleaner/additionalFee',
  component: additionalFeePage
}

// 丽家会管家即时账务详情
export const housekeeperBillList = {
  path: 'cleaner/housekeeperBillList',
  component: HousekeeperBillList
}

export const cleaningTaskList = {
  path: 'cleaner/cleaningTaskList',
  component: CleaningTaskList
}

export const paymentDetails = {
  path: 'cleaner/paymentDetails',
  component: PaymentDetails
}


// WEBPACK FOOTER //
// ./src/router/cleaner.js